import Vue from 'vue';

export default {
    deleteNote(noteId) {
        return Vue.axios.delete(`/v1.0/notes/${noteId}`);
    }
};
